import {
    LISTAFAMILIARES_SUCCESS,
    LISTAFAMILIARES_LOADING,
    LISTAFAMILIARES_ERROR,
    LISTAFAMILIARES_RESET,
    RESET_PORTAL_CONTEXT,
  } from "../ActionTypes";
import listaFamiliaresInitialState from "../initialStates/listaFamiliaresInitialState";

const listaFamiliares = (state, { payload, type }) => {
  switch (type) {
    case LISTAFAMILIARES_LOADING:
      return {
        ...state,
        listaFamiliares: {
          ...state.listaFamiliares,
          error: false,
          loading: true,
        },
      };
    case LISTAFAMILIARES_SUCCESS:
      return {
        ...state,
        listaFamiliares: {
          ...state.listaFamiliares,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case LISTAFAMILIARES_ERROR:
      return {
        ...state,
        listaFamiliares: {
          ...state.listaFamiliares,
          error: payload,
          loading: false,
        },
      };
    case LISTAFAMILIARES_RESET:
      return listaFamiliaresInitialState;
    case RESET_PORTAL_CONTEXT:
      return listaFamiliaresInitialState;

    default:
      return state;
  }
};

export default listaFamiliares;